/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Button, Dialog, Grid, Typography2, breakpoints, useMediaQuery } from '@coursera/cds-core';
import { CheckIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

const styles = {
  skillItem: css`
    display: flex;
    align-items: flex-start;
    gap: 0;
    margin-bottom: var(--cds-spacing-50);
  `,
  skillText: css`
    flex: 1;
    margin: 0;
  `,
  dottedSeparator: css`
    position: relative;
    bottom: 2px;
  `,
};

type Props = {
  skillExpressions: string[];
  onClose: () => void;
};

const SkillExpressionsDialog = ({ skillExpressions, onClose }: Props) => {
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  return (
    <Dialog open={true} onClose={onClose}>
      <Dialog.HeadingGroup>{_t('Skills')}</Dialog.HeadingGroup>
      <Dialog.Content>
        {skillExpressions.map((skillExpression) => (
          <Grid container key={skillExpression} direction="row" wrap="nowrap" spacing={8}>
            <Grid item>
              <CheckIcon size="medium" />
            </Grid>
            <Grid item>
              <Typography2
                variant={isMobile ? 'bodySecondary' : 'bodyPrimary'}
                component="p"
                color="body"
                css={styles.skillText}
              >
                {skillExpression}
              </Typography2>
            </Grid>
          </Grid>
        ))}
      </Dialog.Content>
      <Dialog.Actions>
        <Button variant="primary" onClick={onClose}>
          {_t('Close')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default SkillExpressionsDialog;
